// eslint-disable-next-line no-restricted-imports -- DO NOT COPY THIS LINE. See docs/lints.md.
import { PlayerMedicalRow } from "@suns/api/generated-client/apollo";
import { cn, Flex, Text } from "@suns/design-system";

export function PlayerMedical({
  medical,
  print = false,
  title,
}: {
  medical: PlayerMedicalRow;
  print?: boolean;
  title?: string;
}) {
  if (!medical) return null;

  const { overallScore, medicalScore, orthopedicScore, grade, notes } = medical;

  const medicalScores = [
    {
      label: "Overall",
      value: overallScore,
    },
    {
      label: "Medical",
      value: medicalScore,
    },
    {
      label: "Ortho",
      value: orthopedicScore,
    },
  ];

  return (
    <Flex direction="down" gap="sm">
      <Text muted heading>
        {title}
      </Text>

      <Flex direction="right" gap="md">
        {medicalScores.map(({ label, value }) => (
          <Flex
            key={label}
            direction="down"
            align="center"
            className={cn(
              "rounded-lg border border-gray-300 p-2",
              print && "px-2 py-1"
            )}
          >
            <Text size="xs" heading>
              {label}
            </Text>
            <Flex align="center">
              <Text
                size={print ? "lg" : "xl"}
                heading
                className={cn(
                  value === 3 && "text-green-600",
                  value === 2 && "text-black",
                  value === 1 && "text-red-600",
                  value === null && "mb-1 text-sm text-gray-400"
                )}
              >
                {value ?? "--"}
              </Text>
              <Flex align="center" className="pb-1">
                <Text muted heading size={print ? "sm" : "xs"}>
                  /
                </Text>
                <Text muted heading size={print ? "sm" : "xs"}>
                  3
                </Text>
              </Flex>
            </Flex>
          </Flex>
        ))}
      </Flex>

      <Flex direction="down" gap="sm">
        <Text size={print ? "xs" : "md"} heading>
          {grade}
        </Text>
        <ul className="list-disc pl-4">
          {notes?.split("\n").map((note: string) => (
            <li className={cn(print && "text-2xs")} key={note}>
              {note.replace(/[^\w\s.,!?-]/g, "")}
            </li>
          ))}
          <li className={cn(print && "text-2xs")}>
            Additional medical information available upon request.
          </li>
        </ul>
      </Flex>
    </Flex>
  );
}
